/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var constants = {
    ENDPOINT_CMS_CAMPAIGN: '/msapi/idp-content-orchestration/v1/idpcms/services/campaign',
    ENDPOINT_CMS_CAMPAIGN_FALLBACK: '/idpcms/services/prod/campaign.cmsfeed.js',
    ENDPOINT_TIMEOUT: 20000
};

function makeRequest(url, config) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var complete = false;
                    var timeout = setTimeout(function () {
                        complete = true;
                        console.error("CampaignCmsFeed: Request timed out. URL: " + url);
                        reject('timed out');
                    }, constants.ENDPOINT_TIMEOUT);
                    fetch(url, __assign({ mode: 'cors', headers: { 'Content-Type': 'application/json' } }, config)).then(function (res) {
                        clearTimeout(timeout);
                        if (res && res.ok && !complete) {
                            return res.json();
                        }
                        reject(res.json());
                    }).then(function (res) {
                        resolve(res);
                    });
                })];
        });
    });
}
/** get and return the cleaned campaign CMS content for campaign feed */
function getCampaignCmsFeed() {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makeRequest(constants.ENDPOINT_CMS_CAMPAIGN, {
                        method: 'GET',
                    }).then(function (res) {
                        var _a, _b;
                        var data = (_b = (_a = res["idp-cms-feed"]) === null || _a === void 0 ? void 0 : _a.campaign) === null || _b === void 0 ? void 0 : _b.contentFragments;
                        return data;
                    }).catch(function () { return __awaiter(_this, void 0, void 0, function () {
                        var data;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    console.error("CampaignCmsFeed: CMS campaign feed API call failed");
                                    return [4 /*yield*/, getCampaignCmsFeedFallback()];
                                case 1:
                                    data = _a.sent();
                                    return [2 /*return*/, data];
                            }
                        });
                    }); })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function getCampaignCmsFeedFallback() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makeRequest(constants.ENDPOINT_CMS_CAMPAIGN_FALLBACK, {
                        method: 'GET',
                    }).then(function (res) {
                        var _a, _b;
                        var data = (_b = (_a = res["idp-cms-feed"]) === null || _a === void 0 ? void 0 : _a.campaign) === null || _b === void 0 ? void 0 : _b.contentFragments;
                        return data;
                    }).catch(function () {
                        console.error("CampaignCmsFeedFallback: CMS campaign feed fallback API call failed");
                        return null;
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}

var TTL_MILLISECONDS = 7200000;
var getCampaignCmsFromStorageWithExpiry = function () {
    if (window && window.localStorage) {
        var itemStr = localStorage.getItem('campaign_cms_feed');
        if (!itemStr) {
            return null;
        }
        var item = JSON.parse(itemStr);
        var now = new Date();
        if (now.getTime() > item.expiry) {
            localStorage.removeItem('campaign_cms_feed');
            return null;
        }
        return item.value;
    }
};
var setCampaignCmsToStorageWithExpiry = function (feedData) {
    if (window && window.localStorage) {
        var now = new Date();
        var item = {
            value: feedData,
            expiry: now.getTime() + TTL_MILLISECONDS,
        };
        localStorage.setItem('campaign_cms_feed', JSON.stringify(item));
    }
};
var getCampaignIdentifier = function (skus, productCategory) {
    if (skus === void 0) { skus = []; }
    if (productCategory === void 0) { productCategory = 'Wireless'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var campaignCmsFeed, campaigns, selectedCampaignId;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    campaignCmsFeed = getCampaignCmsFromStorageWithExpiry();
                    if (!!campaignCmsFeed) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCampaignCmsFeed()
                        // Returning empty string if apis failed
                    ];
                case 1:
                    campaignCmsFeed = _c.sent();
                    // Returning empty string if apis failed
                    if (!campaignCmsFeed) {
                        return [2 /*return*/, ''];
                    }
                    setCampaignCmsToStorageWithExpiry(campaignCmsFeed);
                    _c.label = 2;
                case 2:
                    campaigns = Object.values((_a = campaignCmsFeed) === null || _a === void 0 ? void 0 : _a.campaign);
                    selectedCampaignId = (_b = campaigns) === null || _b === void 0 ? void 0 : _b.reduce(function (prevValue, campaign) {
                        var _a, _b, _c, _d, _e, _f, _g;
                        var campaignId = prevValue;
                        if (!campaignId) {
                            var today = new Date();
                            var campaignStartDate = new Date((_a = campaign) === null || _a === void 0 ? void 0 : _a.startDate);
                            var campaignEndDate = new Date((_b = campaign) === null || _b === void 0 ? void 0 : _b.endDate);
                            var isCampaignActive = campaignStartDate <= today && campaignEndDate >= today;
                            var isCategoryPresent = !!((_d = (_c = campaign) === null || _c === void 0 ? void 0 : _c.productcategory) === null || _d === void 0 ? void 0 : _d.find(function (category) { var _a; return ((_a = category) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === productCategory.toLowerCase(); }));
                            if (!isCampaignActive) {
                                campaignId = '';
                                console.log('campaign-identifier: campaignid is not active');
                            }
                            else if (isCategoryPresent && ((_e = skus) === null || _e === void 0 ? void 0 : _e.length) === 0) {
                                campaignId = (_f = campaign) === null || _f === void 0 ? void 0 : _f.id;
                            }
                            else if (isCategoryPresent) {
                                (_g = skus) === null || _g === void 0 ? void 0 : _g.forEach(function (sku) {
                                    var _a, _b, _c;
                                    var isSkuPresent = !!((_b = (_a = campaign) === null || _a === void 0 ? void 0 : _a.participatingOffers) === null || _b === void 0 ? void 0 : _b.find(function (participatingSku) { var _a, _b, _c, _d, _e; return ((_b = (_a = participatingSku) === null || _a === void 0 ? void 0 : _a.master) === null || _b === void 0 ? void 0 : _b.type) === 'sku' && ((_e = (_d = (_c = participatingSku) === null || _c === void 0 ? void 0 : _c.master) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.includes(sku)); }));
                                    if (isSkuPresent) {
                                        campaignId = (_c = campaign) === null || _c === void 0 ? void 0 : _c.id;
                                    }
                                    else {
                                        console.log('campaign-identifier: sku is missing in participatingOffers');
                                    }
                                });
                            }
                        }
                        return campaignId;
                    }, '');
                    if (!selectedCampaignId) {
                        console.log('campaign-identifier: campaign id is not present');
                    }
                    return [2 /*return*/, selectedCampaignId || ''];
            }
        });
    });
};

export { getCampaignIdentifier };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sales/campaign-identifier/dist/campaign-identifier.es.js
// module id = 2394
// module chunks = 8